import { Injectable } from '@angular/core';
import { getMatchModes, WIDGET_CONSTANTS } from '@wms/core';
import { forEach, cloneDeep } from "lodash-es";
import { VARIABLE_CONSTANTS } from '@wms/variables';
import {ProjectService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})
export class BaseVariablePropertyFactoryService {
  variableEventOptions: any = []; /*A copy of the variable to preserve the actual value.*/
  variableRegex = '^[a-zA-Z_][A-Za-z0-9_]+$';
  result: any;
  matchModes: any;
  properties: any;
  propertyGroups: any;
  variableTypes: string[] = ['wm.Variable', 'wm.ServiceVariable', 'wm.CrudVariable', 'wm.LiveVariable', 'wm.LoginVariable', 'wm.LogoutVariable', 'wm.NavigationVariable', 'wm.NotificationVariable', 'wm.TimerVariable', 'wm.WebSocketVariable','wm.DeviceVariable'];
  variableMap: any = {};
  serviceToCategoryMap: any = {};

  constructor(private projectService: ProjectService) {
    this.matchModes = getMatchModes();
    this.initServiceToCategoryMap();
    /* make events compatible to select widget options */
    forEach(cloneDeep(WIDGET_CONSTANTS.EVENTS_OPTIONS), (event: any) => {
      this.variableEventOptions.push({ 'name': event, 'category': 'Default' });
    });
    this.result = {
      "properties": {
        "wm.Variable": {
          "name": { "type": "string", "required": true, "pattern": this.variableRegex },
          "type": { "type": "list", "widgettype": "typeahead", "options": { "string": "LABEL_STRING", "boolean": "LABEL_BOOLEAN", "number": "LABEL_NUMBER", "date": "LABEL_DATE", "entry": "LABEL_ENTRY" }, "value": "string", "required": true },
          "isList": { "type": "boolean", "value": false },
          "twoWayBinding": { "type": "boolean", "hide": true, "value": false },
          "owner": { "type": "list", "options": { "Page": "LABEL_PAGE", "App": "LABEL_APPLICATION" }, "value": "Page" },
          "editJson": { "type": "json" },
          "isBound": { "type": "boolean" },
          "dataSet": { "type": "string", "value": { dataValue: "" }, "hide": true },
          "dataBinding": { "type": "list", "value": [{ "target": "dataValue", "type": "string" }], "hide": true },
          "saveInPhonegap": { "type": "boolean", "value": false, "hide": true }
        },
        "wm.ServiceVariable": {
          "isList": { "hide": true, "required": false },
          "editJson": { "hide": true, "required": false },
          "dataSet": { "type": "string", "value": [], "hide": true },
          "type": { "hide": true, "required": false },
          "maxResults": { "type": "number", "value": 20, "disabled": true, "hide": true },
          "orderBy": { "type": "string", "placeholder": "field1 asc,field2 desc", "hide": true },
          "service": { "type": "list", "required": true, "widgettype": "typeahead", "editonly": true, "isprimary": true },
          "operation": { "type": "list", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name', "isprimary": true, "hide": true },
          "operationType": { "type": "string", "hide": true },
          "startUpdate": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false },
          "autoUpdate": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": true },
          "inFlightBehavior": { "type": "list", "options": { "doNotExecute": "doNotExecute", "executeLast": "executeLast", "executeAll": "executeAll" }, "value": "executeLast" },
          "transformationRequired": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false },
          "columnField": { "type": "list", "options": {}, "hide": true },
          "dataField": { "type": "list", "options": {}, "hide": true },
          "dataBinding": { "type": "list", "value": [], "hide": true },
          "spinnerContext": { "type": "list", "options": { "": "", "page": "page" }, "placeholder": "Search Widgets", "widgettype": "typeahead" },
          "spinnerMessage": { "type": "string" },

          /* Events */
          "onCanUpdate": { "type": 'event', "options": this.variableEventOptions },
          "onBeforeUpdate": { "type": 'event', "options": this.variableEventOptions },
          "onResult": { "type": 'event', "options": this.variableEventOptions },
          "onBeforeDatasetReady": { "type": 'event', "options": this.variableEventOptions },
          "onSuccess": { "type": 'event', "options": this.variableEventOptions },
          "onError": { "type": 'event', "options": this.variableEventOptions },
          "onProgress": { "type": 'event', "options": this.variableEventOptions, "hide": true },
          "onAbort": { "type": 'event', "options": this.variableEventOptions, "hide": true }
        },
        "wm.CrudVariable": {
          "isList": { "hide": true, "required": false },
          "editJson": { "hide": true, "required": false },
          "dataSet": { "type": "string", "value": [], "hide": true },
          "type": { "hide": true, "required": false },
          "maxResults": { "type": "number", "value": 20, "disabled": true, "hide": true },
          "orderBy": { "type": "string", "placeholder": "field1 asc,field2 desc", "hide": true },
          "service": { "type": "list", "required": true, "widgettype": "typeahead", "editonly": true, "isprimary": true },
          "operation": { "type": "list", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name', "isprimary": true, "hide": true },
          "operationType": { "type": "string", "hide": true },
          "crudOperationId": { "type": "string", "hide": true },
          "startUpdate": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": true },
          "autoUpdate": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false },
          "inFlightBehavior": { "type": "list", "options": { "doNotExecute": "doNotExecute", "executeLast": "executeLast", "executeAll": "executeAll" }, "value": "executeLast" },
          "transformationRequired": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false },
          "columnField": { "type": "list", "options": {}, "hide": true },
          "dataField": { "type": "list", "options": {}, "hide": true },
          "dataBinding": { "type": "object", "value": {}, "hide": true },
          "spinnerContext": { "type": "list", "options": { "": "", "page": "page" }, "placeholder": "Search Widgets", "widgettype": "typeahead" },
          "spinnerMessage": { "type": "string" },

          /* Events */
          "onCanUpdate": { "type": 'event', "options": this.variableEventOptions },
          "onBeforeUpdate": { "type": 'event', "options": this.variableEventOptions },
          "onResult": { "type": 'event', "options": this.variableEventOptions },
          "onBeforeDatasetReady": { "type": 'event', "options": this.variableEventOptions },
          "onSuccess": { "type": 'event', "options": this.variableEventOptions },
          "onError": { "type": 'event', "options": this.variableEventOptions },
          "onProgress": { "type": 'event', "options": this.variableEventOptions, "hide": true },
          "onAbort": { "type": 'event', "options": this.variableEventOptions, "hide": true }
        },
        "wm.LiveVariable": {
          "service": { "hide": true, "required": false },
          "editJson": { "hide": true },
          "transformationRequired": { "hide": true },
          "liveSource": { "type": "list", "required": true, "widgettype": "typeahead", "isprimary": true },
          "type": { "hide": false, "options": {}, value: "", "required": true, "widgettype": "typeahead", "isprimary": true },
          "operation": { "isprimary": true, "hide": false, "groupBy": "", "options": { "read": "read", "insert": "insert", "update": "update", "delete": "delete" }, "value": "read", "widgettype": "typeahead", 'propertyName': '' },
          "maxResults": { "disabled": false, "hide": false },
          "designMaxResults": { "type": "number", "value": 10 },
          "ignoreCase": { "hide": true, "type": "boolean", "value": true },
          "matchMode": { "hide": true, "type": "list", "options": this.matchModes, "value": "startignorecase" },
          "orderBy": { "type": "string", "placeholder": "field1 asc,field2 desc", "hide": false, "widgettype": "order-by", "order": "desc" },
          "autoUpdate": { "value": true },
          "startUpdate": { "value": true }
        },
        "wm.LoginVariable": {
          "transformationRequired": { "hide": true },
          "isList": { value: "" },
          "maxResults": { value: "" },
          "operation": { "hide": true, "required": false },
          "service": { "hide": true, "required": false },
          "dataSet": { "value": {} },
          "dataBinding": { "type": "list", "value": [{ "target": "j_username", "type": "string" }, { "target": "j_password", "type": "string" }, { "target": "j_rememberme", "type": "boolean" }], "hide": true },
          "startUpdate": { "value": false },
          "autoUpdate": { "value": false },
          "useDefaultSuccessHandler": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": true }
        },
        "wm.LogoutVariable": {
          "transformationRequired": { "hide": true },
          "isList": { value: "" },
          "maxResults": { value: "" },
          "operation": { "hide": true, "required": false },
          "service": { "hide": true, "required": false },
          "dataSet": { "value": "" },
          "dataBinding": { "value": "" },
          "startUpdate": { "hide": true, "value": "" },
          "autoUpdate": { "hide": true, "value": "" },
          "redirectTo": { "type": "list", "options": [], value: "", "placeholder": "Search Redirect To", "widgettype": "typeahead" },
          "useDefaultSuccessHandler": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": true }
        },
        "wm.NavigationVariable": {
          "name": { "type": "string", "required": true, "pattern": this.variableRegex },
          "owner": { "type": "list", "options": { "Page": "LABEL_PAGE", "App": "LABEL_APPLICATION" }, "value": "Page" },
          "operation": { "type": "list", "required": true, "options": { "goToPreviousPage": "Previous Page", "gotoPage": "Page", "gotoTab": "Tab", "gotoAccordion": "Accordion" }, "value": "gotoPage", "isprimary": true },
          "dataBinding": { "type": "string", "value": [], "hide": true },
          "pageTransitions": { "type": "list", "widgettype": "typeahead", "options": { "none": "none", "slide": "slide", "pop": "pop", "fade": "fade", "flip": "flip" }, "value": "none", "hide": true },
          "cacheable": { "type": "list", "options": { "": "", "true": "true", "false": "false" }, "value": "", "hide": true },
          "dataSet": { "hide": true, "value": [] }
        },
        "wm.NotificationVariable": {
          "name": { "type": "string", "required": true, "pattern": this.variableRegex },
          "owner": { "type": "list", "options": { "Page": "LABEL_PAGE", "App": "LABEL_APPLICATION" }, "value": "Page" },
          "operation": { "type": "list", "required": true, "options": { "alert": "alert", "confirm": "confirm", "toast": "toast" }, "value": "alert", "isprimary": true }, //"prompt", "warnOnce" to be added
          "onCancel": { "type": 'event', "options": this.variableEventOptions, "disabled": true, "hide": true },
          "onClose": { "type": 'event', "options": this.variableEventOptions },
          "onOk": { "type": 'event', "options": this.variableEventOptions },
          'onHide': { 'type': 'event', 'options': this.variableEventOptions },
          'onClick': { 'type': 'event', 'options': this.variableEventOptions },
          "dataBinding": { "type": "string", "value": [], "hide": true }
        },
        "wm.TimerVariable": {
          "name": { "type": "string", "required": true, "pattern": this.variableRegex },
          "owner": { "type": "list", "options": { "Page": "LABEL_PAGE", "App": "LABEL_APPLICATION" }, "value": "Page" },
          "startUpdate": { "type": "boolean", "value": false },
          "repeating": { "type": "boolean", "value": false },
          "delay": { "type": "number", "value": 500 },
          "onTimerFire": { "type": "event", "options": this.variableEventOptions }
        },
        "wm.DeviceVariable": {
          "name": { "type": "string", "required": true, "pattern": this.variableRegex },
          "owner": { "type": "list", "options": { "Page": "LABEL_PAGE", "App": "LABEL_APPLICATION" }, "value": "Page" },
          "dataSet": { "type": "string", "value": { dataValue: "" }, "hide": true },
          "dataBinding": { "type": "object", "value": [], "hide": true },
          "service": { "type": "list", "options": [], "widgettype": "typeahead", "required": true, "isprimary": true },
          "operation": { "type": "list", "hide": true, "options": [], "widgettype": "typeahead", "required": true, "isprimary": true },
          "autoUpdate": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false, "hide": true },
          "startUpdate": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false, "hide": true },
          "spinnerContext": { "type": "list", "options": { "": "", "page": "page" }, "placeholder": "Search Widgets", "widgettype": "typeahead", "hide": true },
          "spinnerMessage": { "type": "string", "hide": true },
          "showProgress": { "type": "boolean", "widgettype": "boolean-inputfirst", "value": false, "hide": true },
          /*events*/
          "onSuccess": { "type": "event", "options": this.variableEventOptions },
          "onError": { "type": "event", "options": this.variableEventOptions },
          "onProgress": { "type": "event", "options": this.variableEventOptions, "hide": true },
          "onOnline": { "type": "event", "options": this.variableEventOptions, "hide": true },
          "onOffline": { "type": "event", "options": this.variableEventOptions, "hide": true },
          "onBefore": { "type": "event", "options": this.variableEventOptions, "hide": true }
        },
        "wm.WebSocketVariable": {
          "name": { "type": "string", "required": true, "pattern": this.variableRegex },
          "owner": { "type": "list", "options": { "Page": "LABEL_PAGE", "App": "LABEL_APPLICATION" }, "value": "Page" },
          "dataSet": { "type": "string", "value": [], "hide": true },
          "service": { "type": "list", "required": true, "widgettype": "typeahead" },
          "type": { "hide": true },
          "operation": { "hide": true },
          "operationId": { "hide": true },
          "startUpdate": { "type": "boolean", "widgettype": "boolean", "value": true },
          "dataUpdateStrategy": { "type": "string", "widgettype": "list", "options": { "refresh": "Refresh dataSet", "append": "Add as last record in dataSet", "prepend": "Add as first record in dataSet" }, "value": "refresh" },
          "dataLimit": { "type": "number", "value": 20 },
          "dataBinding": { "type": "list", "value": [], "hide": true },

          /* Events */
          "onBeforeOpen": { "type": 'event', "options": this.variableEventOptions },
          "onOpen": { "type": 'event', "options": this.variableEventOptions },
          "onBeforeMessageSend": { "type": 'event', "options": this.variableEventOptions },
          "onMessageReceive": { "type": 'event', "options": this.variableEventOptions },
          "onError": { "type": 'event', "options": this.variableEventOptions },
          "onBeforeClose": { "type": 'event', "options": this.variableEventOptions },
          "onClose": { "type": 'event', "options": this.variableEventOptions }
        }
      },
      "propertyGroups": [
        /* tabs */
        { "name": "properties", "parent": "" },
        { "name": "data", "parent": "" },
        { "name": "events", "parent": "" },

        /* properties under behavior tab */

        { "properties": ["liveSource", "type", "isList"], "parent": "properties" },
        { "name": "service", "properties": ["service", "operation"], "parent": "properties" },
        { "name": "serveroptions", "properties": ["downloadFile", "matchMode", "maxResults", "designMaxResults", "orderBy", "ignoreCase"], "parent": "properties" },
        { "name": "behavior", "properties": ["useDefaultSuccessHandler", "clearDataOnLogout", "autoUpdate", "startUpdate", "inFlightBehavior", "loadingDialog", "saveInCookie", "refireOnDbChange", "redirectTo", "delay", "repeating", "cacheable", "pageTransitions", "showProgress"], "parent": "properties" },
        { "name": "dataset", "properties": ["dataUpdateStrategy", "dataLimit"], "parent": "properties" },
        { "name": "mobile", "properties": ["saveInPhonegap"], "parent": "properties" },
        { "name": "Inputs", "properties": ["pageName", "viewName", "tabName", "accordionName", "segmentName", "dataBinding"], "parent": "properties", "propertyTarget": 'dataBinding' },
        { "name": "spinner", "properties": ["spinnerContext", "spinnerMessage"], "parent": "properties" },

        /* properties under data tab */
        { "name": "Inputs", "properties": [], "parent": "data", "propertyTarget": 'dataBinding, dataSet' },
        { "name": "inputfields", "properties": [], "parent": "data", "propertyTarget": 'dataBinding' },
        { "name": "filterfields", "properties": [], "parent": "data", "propertyTarget": 'dataBinding' },
        { "name": "bindings", "properties": [], "parent": "data", "propertyTarget": 'dataBinding' },
        { "name": "dataTransformation", "properties": ["transformationRequired", "columnField", "dataField"], "parent": "data" },

        /* properties under events tab */
        { "properties": VARIABLE_CONSTANTS.EVENTS, "parent": "events" }
      ]
    };
    this.properties = this.result.properties;
    this.propertyGroups = this.result.propertyGroups;
    forEach(this.variableTypes, (type: any) => {
      let parentCategories: string[] = [];
      if (type === 'wm.ServiceVariable' || type === 'wm.CrudVariable') {
        parentCategories = ["wm.Variable"];
      } else if (type === 'wm.LiveVariable' || type === 'wm.LoginVariable' || type === 'wm.LogoutVariable') {
        parentCategories =  ["wm.Variable", "wm.ServiceVariable"];
      }
      this.register(type, {}, parentCategories);
    });
  }

  /*
  * function to get all the property groups
  */
  getPropertyGroups() {
    return this.propertyGroups;
  }

  getPropertiesByServiceType(serviceType: any) {
    let props: any = {};
    props[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE] = {
        "liveSource": {"displayName": "Database", "type": "string", "required": true, "widgettype": "typeahead"},
        "target": {"displayName": "Target", "type": "string", "required": false, "hide": "true", "widgettype": "radioset", "options": {"table": "table", "query": "query", "procedure": "procedure"}},
        "table": {"displayName": "Table", "type": "string", "required": true, "widgettype": "typeahead", "hide": true},
        "operation": {"displayName": "Operation", "type": "string", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name', "hide": true}
    };
    props[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.WEB] = {
        "apitype": {"hide": true, "displayName": "API Type", "type": "string", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name', modelPropertyName: 'object'},
        "service": {"displayName": "Service", "type": "string", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name'}
    };
    props[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI] = {
        "apitype": {"hide": true, "displayName": "API Type", "type": "string", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name', modelPropertyName: 'object'},
        "service": {"displayName": "Service", "type": "string", "required": true, "widgettype": "typeahead", groupBy: 'type', 'propertyName': 'name'},
        "target": {"displayName": "Type", "type": "string", "required": true, "hide": "true", "widgettype": "radioset", "options": {"entities": "Entities (CRUD)", "other": "Other Endpoints"}},
        "entity": {"displayName": "Entity", "type": "string", "required": true, "widgettype": "typeahead", "hide": true}
    };
    props[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE_API] = {
        "liveSource": {"displayName": "Database", "type": "string", "required": true, "widgettype": "typeahead"},
        "target": {"displayName": "API Type", "type": "string", "required": true, "hide": "true", "widgettype": "radioset", "options": {"table": "Table APIs", "query": "Query APIs", "procedure": "Procedure APIs"}},
        "table": {"displayName": "Table", "type": "string", "required": true, "widgettype": "typeahead", "hide": true},
        "operation": {"displayName": "API", "type": "string", "required": true, "widgettype": "typeahead", "hide": true}
    };

    if (this.projectService.isNativeMobileApplicationType() && serviceType === VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI) {
        props[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI].target = {"displayName": "Type", "type": "string", "required": true, "hide": "true", "widgettype": "radioset", "options": {"other": "Other Endpoints"}};
    }

    return props[serviceType] || props;
  }

  initServiceToCategoryMap() {
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE] = ['wm.LiveVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE_API] = ['wm.ServiceVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.WEB] = ['wm.ServiceVariable', 'wm.WebSocketVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI] = ['wm.CrudVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.JAVA] = ['wm.ServiceVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.SECURITY] = ['wm.ServiceVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.CUSTOM] = ['wm.Variable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.NAVIGATION] = ['wm.NavigationVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.NOTIFICATION] = ['wm.NotificationVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.LOGIN] = ['wm.LoginVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.LOGOUT] = ['wm.LogoutVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.TIMER] = ['wm.TimerVariable'];
    this.serviceToCategoryMap[VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DEVICE] = ['wm.DeviceVariable'];
  }

  /*
  * function to get the property map for a variable
  */
  getPropertyMap(category: string) {
    return this.variableMap[category] ? this.variableMap[category].propertyMap : undefined;
  }

  /*
  * function to get the properties for a variable
  */
  getProperties(category: string) { // TO DO
    return this.variableMap[category] ? cloneDeep(this.variableMap[category].properties) : {};
  }

  /*
  If parents array is provided, inject the properties from the parents into variable and return,
  else return only the properties of the widget.
  */
  getPropertiesOf(variableCategory: any, parentCategories: any) {
    /* Variable to hold all the properties of the requested variable category */
    let variablePropertiesObject: any = {};
    let tempPropertiesObject: any;
    /* Condition: Check if parent dependencies are there */
    if (!parentCategories) {
      /* This variableCategory doesn't inherit from other variableCategories.
        Fetch the properties of only this variableCategory */
      variablePropertiesObject.variableProps = cloneDeep(this.properties[variableCategory]);
    } else {
      /* If parent categories are present, add their properties to current variable */
      parentCategories = Array.isArray(parentCategories) ? parentCategories : [parentCategories];
      parentCategories.push(variableCategory);
      tempPropertiesObject = {};

      /* construct the properties object by inheriting from parentCategories */
      parentCategories.forEach((parent: any) => {
          /* Fetch properties of individual dependency */
          Object.keys(this.properties[parent]).forEach((propName: any) => {
              let propObj: any = this.properties[parent][propName];
              /* if property is not present create it */
              if (!tempPropertiesObject[propName]) {
                  tempPropertiesObject[propName] = {};
              }
              /* Populate the fetched properties */
              Object.keys(propObj).forEach((key: any) => {
                let value: any = propObj[key];
                tempPropertiesObject[propName][key] = value;
              });

          });
      });
      /* Assign the fetched properties to variableProps object for property panel */
      variablePropertiesObject.variableProps = tempPropertiesObject;
    }

    /* bind the properties with variable object */
    Object.keys(variablePropertiesObject.variableProps).forEach((propName: any) => {
      let propObj: any = variablePropertiesObject.variableProps[propName];
      /* Get the previous value if present, else create new property */
      if (!variablePropertiesObject[propName]) {
        variablePropertiesObject[propName] = (propObj.value === undefined) ? "" : propObj.value;
      }
    });

    /* return the completed object */
    return variablePropertiesObject;
  }

  getCategoriesByServiceType(serviceType: any) {
    return this.serviceToCategoryMap[serviceType];
  }

  /*
  * function to register a variable
  */
  register(category: string, properties: any, parentCategories: any) {
    this.variableMap[category] = {};

    Object.assign(properties, this.getPropertiesOf(category, parentCategories));

    this.variableMap[category].propertyMap = properties.variableProps;
    delete properties.variableProps;
    this.variableMap[category].properties = properties;

    // this.variableMap[category].methods = methods;
  }
}
